/* eslint no-param-reassign: "off" */
import * as types from './mutation-types';

export default {
  [types.GET_PROFILE_FIELDS_SUCCESS]: (state, response) => {
    state.profileFields = response.data;
  },
  [types.GET_PROFILES_REQUEST]: state => {
    state.loadingProfiles = true;
    state.loadProfilesFailed = false;
    state.loadProfilesSuccess = false;
  },
  [types.GET_PROFILES_FAILURE]: (state, error) => {
    state.loadingProfiles = false;
    state.loadProfilesFailed = true;
    state.loadProfilesError = error;
  },
  [types.GET_PROFILES_SUCCESS]: (state, response) => {
    state.loadingProfiles = false;
    state.loadProfilesSuccess = true;
    state.profiles = response.data;
  },
  [types.LOAD_MORE_PROFILES_SUCCESS]: (state, response) => {
    state.loadingProfiles = false;
    state.loadProfilesSuccess = true;
    state.profiles = [...state.profiles, ...response.data];
  },
  [types.SELECT_PROFILES_PROFILE]: (state, profile) => {
    state.selectedProfile = profile;
  },
  [types.SET_PROFILES_COUNT]: (state, profilesCount) => {
    state.profilesCount = profilesCount;
  },
  [types.SHOW_PROFILES_DIALOG]: (state, condition) => {
    state.profileDialogVisible = condition;
  },
  [types.SHOW_DISPLAY_PROFILES]: (state, value) => {
    state.showDisplayProfiles = value;
  },
  [types.SET_PAGE_COUNT]: (state, page) => {
    state.page = page;
  },
  [types.RESET_PAGE_COUNT]: state => {
    state.page = 1;
  },
  [types.RESET_PROFILES]: state => {
    state.profileFilterFields = {};
    state.profiles = [];
    state.page = 1;
    state.searchQuery = null;
  },
  [types.SET_IS_SEARCHING]: state => {
    state.isSearching = true;
  },
  [types.SET_SEARCH_QUERY]: (state, query) => {
    state.searchQuery = query;
  },
  [types.SET_DEMOGRAPHIC_FILTERS]: (state, query) => {
    state.profileFilters.demographicFilters[query.filterKeyValue] = query.val;
  },
  [types.SET_CAMPAIGN_SURVEY_FILTERS]: (state, query) => {
    state.profileFilters.campaignSurveyFilters = query;
  },
  [types.SET_PROFILES_FILTER_FIELDS]: (state, query) => {
    state.profileFilterFields = query;
  },
  [types.GET_PROFILE_IDENTITY_REQUEST]: state => {
    state.loadingProfileIdentity = true;
    state.loadProfileIdentityFailed = false;
    state.loadProfileIdentitySuccess = false;
    state.selectedProfile = {};
  },
  [types.GET_PROFILE_IDENTITY_FAILURE]: state => {
    state.loadingProfileIdentity = false;
    state.loadProfileIdentityFailed = true;
    state.loadProfileIdentitySuccess = false;
  },
  [types.GET_PROFILE_IDENTITY_SUCCESS]: (state, response) => {
    state.loadingProfileIdentity = false;
    state.loadProfileIdentityFailed = false;
    state.loadProfileIdentitySuccess = true;

    if (response.length) {
      state.selectedProfile = response[0];
    } else {
      state.selectedProfile = {};
    }
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/profile/mutations.js